module.exports = __webpack_public_path__ + "img/gemeente-logo.5c046ec8.png";